// =============================================
// src/components/EmptyState.jsx
// =============================================

import React from "react";

export default function EmptyState({ onPick }) {
  return (
    <div
      style={{
        marginTop: 16,
        padding: 20,
        border: "1px solid #e2e8f0",
        borderRadius: 12,
        background: "rgba(240, 249, 255, 0.6)",
      }}
    >
      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 10 }}>Try an example:</div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {[
          "What are the strongest APOE-ε4 microglial targets linked to lipid metabolism and immune signaling?",
          "Describe gene expression signatures of the complement cascade in AD and rank drugs predicted to dampen neuroinflammatory interactions.",
          "Summarize evidence from Alzforum-curated PubMed IDs supporting BIN1 as a druggable AD target, and identify candidate compounds.",
          "What are the predicted ligand–receptor partners of SORL1 in human cortex, and how are they altered are AD pathology?",
        ].map((ex, i) => {
          const bg = [
            {
              background:
                "linear-gradient(135deg, rgba(14, 165, 233, 0.08) 0%, rgba(6, 182, 212, 0.05) 100%)",
              borderColor: "rgba(14, 165, 233, 0.2)",
            },
            {
              background:
                "linear-gradient(135deg, rgba(6, 182, 212, 0.08) 0%, rgba(20, 184, 166, 0.05) 100%)",
              borderColor: "rgba(6, 182, 212, 0.2)",
            },
            {
              background:
                "linear-gradient(135deg, rgba(20, 184, 166, 0.08) 0%, rgba(34, 197, 94, 0.05) 100%)",
              borderColor: "rgba(20, 184, 166, 0.2)",
            },
            {
              background:
                "linear-gradient(135deg, rgba(20, 184, 166, 0.08) 0%, rgba(34, 197, 94, 0.05) 100%)",
              borderColor: "rgba(20, 184, 166, 0.2)",
            },
          ];
          return (
            <button
              key={i}
              style={{
                background: bg[i].background,
                border: `1px solid ${bg[i].borderColor}`,
                padding: "10px 16px",
                borderRadius: 8,
                fontSize: 13,
                cursor: "pointer",
                fontWeight: 500,
                color: "#1e293b",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(14, 165, 233, 0.15)";
                e.currentTarget.style.filter = "brightness(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.filter = "brightness(1)";
              }}
              onClick={() => onPick(ex)}
            >
              {ex}
            </button>
          );
        })}
      </div>
    </div>
  );
}